let cleanupHeaderScroll = null;

export function headerScroll(root = document) {
    if (cleanupHeaderScroll) {
        cleanupHeaderScroll();
        cleanupHeaderScroll = null;
    }

    const header = root.querySelector('[data-header]');
    const desktop = window.matchMedia('(min-width: 992px)');

    if (!header) return;

    let lastScroll = window.scrollY;

    const handleScroll = () => {
        const currentScroll = window.scrollY;

        if (!desktop.matches || currentScroll < 99) {
            header.classList.remove('is-hidden');
            lastScroll = currentScroll;
            return;
        }

        header.classList.toggle(
            'is-hidden',
            currentScroll > lastScroll
        );

        lastScroll = currentScroll;
    };

    window.addEventListener('scroll', handleScroll, { passive: true });

    cleanupHeaderScroll = () => {
        window.removeEventListener('scroll', handleScroll);
    };
}